import React, { FC } from 'react'

import Modal from './Modal'
import WorkStyleDetail from './WorkStyleDetail'

interface Props {
  type: string
  display: boolean,
  closeCallback: () => void
}

const WorkStyleModal: FC<Props> = (props) => {
  const {
    type,
    display,
    closeCallback,
  } = props

  const closeModal = () => {
    closeCallback()
  }

  return (
    <Modal
      modalSize="large"
      show={display}
      closeCallback={closeModal}
      closeable={type !== "first" && type !== "force"}
      wrapperClass="work_style_modal"
    >
      <WorkStyleDetail
        closeCallback={closeModal}
        type={type}
      />
    </Modal>
  )
}

export default WorkStyleModal
